import { useState } from 'react';
import type { PropsWithChildren } from 'react';

import { ampli } from '~shared/analytics';
import { config } from '~shared/config';

import { AuthApiContext } from './auth-api-context';
import { GatewayAuthApi } from './gateway-auth-api';

export const AuthApiProvider = ({ children }: PropsWithChildren) => {
  const [authApi] = useState(
    () =>
      new GatewayAuthApi(config.authClientId, config.apiHost, (event) => {
        ampli.client.track(event);
      })
  );

  return (
    <AuthApiContext.Provider value={authApi}>
      {children}
    </AuthApiContext.Provider>
  );
};
